import { Injectable, signal } from "@angular/core";
import { ContactDto } from "../model/contact.model";
import { ContactApi } from "../service/contact.api";
import { finalize, tap } from "rxjs";


@Injectable({ providedIn: 'root' })
export class ContactState {
    private readonly _contact = signal<ContactDto | null>(null);
    private readonly _loading = signal<boolean>(true);
    private readonly _isMessageSent = signal<boolean>(false);

    readonly contact = this._contact.asReadonly();
    readonly loading = this._loading.asReadonly();
    readonly isMessageSent = this._isMessageSent.asReadonly();

  constructor(    
    private _contactApi: ContactApi
) {}

  init(){
    this._loading.set(true);

    var contact: ContactDto = new ContactDto();
    contact.id=0;
    contact.dateCreation = new Date(Date.now());
    this._contact.set(contact);

    this._loading.set(false);
  }
  
  // load(idCustomer: number) {
  //   this._loading.set(true);

  //   this._contactApi.getById(idCustomer).subscribe({
  //     next: contact => {
  //       this._contact.set(contact);
  //       //chargement de la selection
  //       // this._contactSelectionState.load(contact);
  //       this._loading.set(false);
  //     },
  //     error: err => {
  //       console.error('Erreur lors du chargement contact', err);
  //       this._loading.set(false);
  //     }
  //   });
  // }

  save(contactDto: ContactDto) {
    this._loading.set(true);

    this._contactApi.save(contactDto)
      .pipe(
        tap(() => this._loading.set(true)),
        finalize(() => this._loading.set(false))
      )
      .subscribe({
        next: contact => {
          this._contact.set(contact); 
          this._isMessageSent.set(true);
        },
        error: err => {
          console.error('Erreur api', err);
        }
      });
  }

  patch(changes: Partial<ContactDto>) {
    this._contact.update(u => u ? { ...u, ...changes } : u);
  }


}
